import React from "react";
import PluginPlaceholder from "../../_editor/components/canvas/plugin_placeholder/PluginPlaceholder";
import "./_fillinblank.scss";
import i18n from "i18next";
import { contentT } from "../../common/content_language";
import { setRgbaAlpha } from "../../common/common_tools";
/* eslint-disable react/prop-types */

export function FillInBlank(base) {
  return {
    getConfig: function () {
      return {
        name: "FillInBlank",
        displayName: IdealStudio.i18n.t("FillInBlank.PluginName"),
        category: "evaluation",
        icon: "chrome_reader_mode",
        initialWidth: "100%",
        initialHeight: "100%",
        initialWidthSlide: "100%",
        initialHeightSlide: "100%",
        flavor: "react",
        isComplex: true,
        defaultCorrectAnswer: 0,
        defaultCurrentAnswer: false,
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            __score: {
              __name: i18n.t("configuration"),
              icon: "build",
              buttons: {
                /*  nBoxes: {
                                    __name: i18n.t("FillInBlank.Number"),
                                    type: 'number',
                                    value: state.nBoxes,
                                    max: 10,
                                    min: 1,
                                }, */
                showFeedback: {
                  __name: i18n.t("FillInBlank.ShowFeedback"),
                  type: "checkbox",
                  checked: state.showFeedback,
                },
                buttons: {
                  __name: i18n.t("MultipleChoice.WhichButtons"),
                  type: "radio",
                  value: state.buttons,
                  options: ["tryAgain", "seeAnswer"],
                  labels: [i18n.t("MultipleChoice.tryAgain"), i18n.t("MultipleChoice.seeAnswer")],
                },
              },
            },
            style: {
              __name: IdealStudio.i18n.t("FillInBlank.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("FillInBlank.padding"),
                  type: "number",
                  value: 10,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("FillInBlank.background_color"),
                  type: "color",
                  value: "#ffffff",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("FillInBlank.border_size"),
                  type: "number",
                  value: 1,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("FillInBlank.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("FillInBlank.border_color"),
                  type: "color",
                  value: "#dbdbdb",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("FillInBlank.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("FillInBlank.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
              },
            },
          },
        },
      };
    },
    getInitialState: function () {
      return {
        nBoxes: 1,
        showFeedback: true,
        allowPartialScore: false,
        buttons: "tryAgain",
      };
    },
    getRenderTemplate: function (state, props = {}) {
      let answers = [];

      // Generate default text with blank spaces
      let nBoxes = state.nBoxes || 1;
      // Add a blank pattern for each box so the default question actually has a
      // fillable blank (the parser turns "#----answer----#" into an input).
      let blanks = "";
      for (let i = 0; i < nBoxes; i++) {
        blanks += " #----answer" + (i + 1) + "----#";
      }
      let defaultText = "<p>" + contentT("FillInBlank.Statement") + blanks + "</p>";

      return (
        <div className={"exercisePlugin fillinblankPlugin"}>
          <div className={"row"} key={0}>
            <div className={"col-xs-12"}>
              <PluginPlaceholder
                {...props}
                key="1"
                pluginContainerName={i18n.t("FillInBlank.Question")}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: {
                      __i18nKey: "FillInBlank.Statement",
                      __suffix: blanks,
                      __text: defaultText,
                    },
                  },
                ]}
                pluginContainer={"Question"}
                isFibQuestion
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-2"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"TrueFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.TrueFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
          <div
            className={"row feedbackRow"}
            key={-3}
            style={{ display: state.showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
              }}
            >
              <PluginPlaceholder
                {...props}
                key="-3"
                pluginContainerName={i18n.t("MultipleChoice.Feedback")}
                pluginContainer={"FalseFeedback"}
                pluginDefaultContent={[
                  {
                    plugin: "BasicText",
                    initialState: { __i18nKey: "MultipleChoice.FalseFeedbackMsg" },
                  },
                ]}
              />
            </div>
          </div>
        </div>
      );
    },
  };
}
/* eslint-enable react/prop-types */
